import type { PropsWithChildren } from 'react';
import { useMemo } from 'react';
import type { VisibilityOnPagesSettingsType } from '../../types';
import { isVisibleOnPage } from '../is-visible-on-page';

interface VisibilityOnPagesWrapperProps {
  widgetVisibilityOnPages: VisibilityOnPagesSettingsType | null;
  editMode?: boolean;
}

export const VisibilityOnPagesWrapper = ({
  children,
  widgetVisibilityOnPages,
  editMode
}: PropsWithChildren<VisibilityOnPagesWrapperProps>) => {
  const shouldDisplay = useMemo(
    () => editMode || isVisibleOnPage(widgetVisibilityOnPages),
    [widgetVisibilityOnPages, editMode]
  );
  return <>{shouldDisplay ? children : null}</>;
};
